import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, App } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { antdTheme } from '@/styles/theme/antd.theme';
import { setMessageApi } from '@/shared/services/http/client';
import '@/styles/global.scss';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 分钟
      gcTime: 10 * 60 * 1000, // 10 分钟
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const AppContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { message } = App.useApp();

  useEffect(() => {
    // 初始化全局 message API
    setMessageApi(message);
  }, [message]);

  return <>{children}</>;
};

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhCN} theme={antdTheme}>
        <App>
          <AppContent>{children}</AppContent>
        </App>
      </ConfigProvider>
    </QueryClientProvider>
  );
};
